import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c191fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-people-signatories" }
const _hoisted_2 = { class: "row search-inputs" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "field_name mb-1" }, "Practice name", -1))
const _hoisted_5 = { class: "select" }
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = { class: "search-bar col-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "field_name mb-1" }, "Search LawID or name", -1))
const _hoisted_9 = { class: "icon-hm" }
const _hoisted_10 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_11 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = { class: "checkbox-button ml-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_15 = { class: "col-3 left-buttons" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "ls-table" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "text" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["colspan"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { "data-label": "LawId" }
const _hoisted_33 = { "data-label": "Name" }
const _hoisted_34 = { "data-label": "Position" }
const _hoisted_35 = { "data-label": "Solely-jointly" }
const _hoisted_36 = { "data-label": "From" }
const _hoisted_37 = { "data-label": "To" }
const _hoisted_38 = {
  "data-label": "Action",
  style: {"text-align":"right"}
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12 right" }

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditSignatoryModal = _resolveComponent("AddEditSignatoryModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.currentPracticeView) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practices, (firm) => {
              return (_openBlock(), _createElementBlock("option", {
                key: firm.practiceCoreId,
                value: firm,
                selected: _ctx.selectedPractice === firm
              }, _toDisplayString(firm.practiceName), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.currentPracticeView]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Enter LawID or name",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.searchKeyword) = $event))
        }, null, 512), [
          [_vModelText, _ctx.searchKeyword]
        ]),
        _createElementVNode("span", _hoisted_9, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
            : (_openBlock(), _createElementBlock("i", _hoisted_11))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showActiveOnly) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showActiveOnly]
          ]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "btn btn-secondary sml",
          disabled: _ctx.loadingContent
        }, "Print as PDF", 8, _hoisted_16),
        _createElementVNode("button", {
          class: "btn btn-secondary sml",
          disabled: _ctx.loadingContent,
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.exportSignatoryCSV(_ctx.signatories)), ["prevent","stop"]))
        }, "Export", 8, _hoisted_17)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                  onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(h.text), 1),
                    (h.sortable)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                        }, _hoisted_24, 2))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_21))
              }), 256))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_LoadingIndicator)
                  ], 8, _hoisted_26)
                ]))
              : (_ctx.errorLoadingContent)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, [
                      _createVNode(_component_ErrorIndicator)
                    ], 8, _hoisted_28)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.signatoriesDisplay.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableHeadings.length
                      }, "No Records", 8, _hoisted_30)
                    ]))
                  : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.signatoriesDisplay.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.applyFilter(_ctx.signatoriesDisplay), (i, indexKey) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: indexKey }, [
                          ((_ctx.showActiveOnly && _ctx.isActive(i) || !_ctx.showActiveOnly) && (_ctx.showPCOnly && i.signatoryType.name == 'PC' || !_ctx.showPCOnly))
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                _createElementVNode("td", _hoisted_32, _toDisplayString(i.lawId), 1),
                                _createElementVNode("td", _hoisted_33, _toDisplayString(i.name), 1),
                                _createElementVNode("td", _hoisted_34, _toDisplayString(i.categoryName), 1),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(i.solelyJointly?.name), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.$formatDate(i.commencedDate)), 1),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(i.terminatedDate ? _ctx.$formatDate(i.terminatedDate) : ''), 1),
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("button", {
                                    class: "btn btn-default sml mr-1",
                                    onClick: $event => (_ctx.edit(i))
                                  }, "Edit", 8, _hoisted_39)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.addNew()))
        }, "Add new signatory")
      ])
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditSignatoryModal, {
          key: 0,
          signatoryRequest: _ctx.signatoryRequest,
          "onUpdate:signatoryRequest": _cache[5] || (_cache[5] = $event => ((_ctx.signatoryRequest) = $event)),
          signatories: _ctx.signatories,
          "onUpdate:signatories": _cache[6] || (_cache[6] = $event => ((_ctx.signatories) = $event)),
          onCloseModal: _cache[7] || (_cache[7] = $event => (_ctx.showAddEditModal = false)),
          selectedPractice: _ctx.currentPracticeView,
          onDataChangedSuccessfully: _cache[8] || (_cache[8] = $event => (_ctx.loadTableData())),
          onStatusChange: _ctx.loadingStateChanged
        }, null, 8, ["signatoryRequest", "signatories", "selectedPractice", "onStatusChange"]))
      : _createCommentVNode("", true)
  ]))
}